export  const roles={
    DISTRIBUTOR: "DISTRIBUTOR",
    ADMIN: "ADMIN",
    USER : "USER"
}